import { render, staticRenderFns } from "./OfferTotal.vue?vue&type=template&id=67dd8448&scoped=true&"
import script from "./OfferTotal.vue?vue&type=script&lang=js&"
export * from "./OfferTotal.vue?vue&type=script&lang=js&"
import style0 from "./OfferTotal.vue?vue&type=style&index=0&id=67dd8448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dd8448",
  null
  
)

export default component.exports